<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel">
                        <h2>Cadastrar Procedimento conflitante</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioDeProcedimentoConflitante" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-12 col-12">
                            <mat-label>Procedimento Conflitante</mat-label>
                            <mat-select value="Procedimento Conflitante" formControlName="procedimentoConflitante"
                                name="procedimentoConflitante" id="procedimentoConflitante" required>
                                <mat-option *ngFor="let procedimento of listaDeProcedimentos" [value]="procedimento">
                                    {{procedimento.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioDeProcedimentoConflitante.controls.procedimentoConflitante.hasError('required')">
                                O campo Procedimento Conflitante é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-12 col-12">
                            <mat-label>Tempo Conflito (Minutos)</mat-label>
                            <input matInput type="number" value="Tempo Conflito (Minutos" class="form-control"
                                id="tempoAtd" trim="blur" name="tempoConflito" formControlName="tempoConflito" min="10"
                                max="720" step="10">
                            <mat-error
                                *ngIf="formularioDeProcedimentoConflitante.controls.tempoConflito.hasError('required')">
                                O campo Tempo Conflito (Minutos) é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioDeProcedimentoConflitante.valid || !procedimento">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="voltarPaginaAnterior()"
                                matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>